import { render, staticRenderFns } from "./CardServicoDiagnostico.vue?vue&type=template&id=6dc63584&scoped=true"
import script from "./CardServicoDiagnostico.vue?vue&type=script&lang=ts"
export * from "./CardServicoDiagnostico.vue?vue&type=script&lang=ts"
import style0 from "./CardServicoDiagnostico.vue?vue&type=style&index=0&id=6dc63584&prod&scoped=true&lang=css"
import style1 from "./CardServicoDiagnostico.vue?vue&type=style&index=1&id=6dc63584&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc63584",
  null
  
)

export default component.exports